export const getLicenseStatus = (status) => {
  switch (status) {
    case "ACT":
      return "Activated";
    case "EXP":
      return "Expired";
    default:
      return "Unknown";
  }
};

export const getLicenseStatusColor = (status) => {
  switch (status) {
    case "Activated":
      return "#3FD3BD";
    case "Expired":
      return "#DE0B15";
    default:
      return "#B5B5B5";
  }
};

export const getLicenseProvider = (licenseKey) => {
  const re = new RegExp(`^\\w{2}-\\w{4}-\\w{5}-\\w{5}-\\w{5}-\\w{5}-\\w{5}$`);
  if (re.exec(licenseKey)) {
    return "Trend Micro";
  }
  return "TXOne";
};

export const getLicenseTypeName = (licenseTypeId) => {
  switch (licenseTypeId) {
    case 1:
      return "EdgeOne Node License";
    case 2:
      return "EdgeFire Software License";
    case 3:
      return "EdgeIPS Software License";
    case 4:
      return "EdgeIPS Pro Software License";
    case 5:
      return "EdgeIPS LE Software License";
    case 6:
      return "EdgeIPS Pro 216 Software License";
    case 7:
      return "EdgeIPS Pro 2008 Software License";
    default:
      return "Unknown";
  }
};
